import { LodgmentTypesDistribution } from '../../../../lodgmentTypes/LodgmentTypesDistribution';
import * as R from 'ramda';
import { CaseSpecification } from '../../../CaseSpecification';

type SetCaseLodgmentTypesDistribution = (
  distribution: LodgmentTypesDistribution
) => (c: CaseSpecification) => CaseSpecification;
export const setCaseLodgmentTypesDistribution: SetCaseLodgmentTypesDistribution = (distribution) =>
  R.assoc('distribution', R.map(R.pick(['lodgmentType', 'rate']), distribution));
